import { NgModule, ModuleWithProviders } from '@angular/core';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TechLibPortalConfig, TechLibPortalInterceptor, TECH_LIB_PORTAL_CONFIG } from './tech-lib-portal.interceptor';

@NgModule({
  declarations: [],
  imports: [],
  exports: [],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TechLibPortalInterceptor, multi: true },
  ],
})
export class TechLibPortalModule {
  static initializeApp(
    config: TechLibPortalConfig
  ): ModuleWithProviders<TechLibPortalModule> {
    return {
      ngModule: TechLibPortalModule,
      providers: [{ provide: TECH_LIB_PORTAL_CONFIG, useValue: config }],
    };
  }

  static setHeaders(config: TechLibPortalConfig) {}
}
